import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { ILinkCard, PositionEnum, SdLinkCardComponent, SdListComponent } from '@seb/web-design-system/core';

import { CmsLinkDSComponentInterface, LinkCardModuleInterface } from '../../../models';
import { LinkMapper, transformHeadlineLevelToTitleLevel } from '../../../mappers';
import { AbstractModuleComponent } from '../abstract-module.component';
import { ImageService } from '../../../services';

@Component({
  selector: 'wc-link-card-module',
  templateUrl: './link-card-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdListComponent,
    SdLinkCardComponent
  ]
})
export class LinkCardModuleComponent extends AbstractModuleComponent<LinkCardModuleInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-base'].filter(Boolean).join(' ');
  }

  linkCards: ILinkCard[] = [];
  positionEnum = PositionEnum;
  titleLevel?: number;
  isFit?: boolean;

  constructor(
    private imageService: ImageService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  override mandatoryComponentFunction = (cmp: CmsLinkDSComponentInterface): boolean => {
    return !!cmp.media && !!cmp.linkName;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.module$.subscribe((module: LinkCardModuleInterface) => {
        this.linkCards = module.componentsObjects.map((cmp) => ({
          media: this.imageService.normalizeMedia(cmp.media),
          link: LinkMapper.cmsLinkToILink(cmp)
        }));
        this.titleLevel = transformHeadlineLevelToTitleLevel(module.titleLevel);
        this.isFit = module.isFit === 'true';

        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }
}
